var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTown1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_1520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 28.9062H17.9688V30.4688H16.4062V28.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 28.9062H14.8438V30.4688H13.2812V28.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 28.9062H21.0938V30.4688H19.5312V28.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 32.0312H21.0938V33.5938H19.5312V32.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 32.0312H17.9688V33.5938H16.4062V32.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 32.0312H14.8438V33.5938H13.2812V32.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 35.1562H21.0938V36.7188H19.5312V35.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 35.1562H17.9688V36.7188H16.4062V35.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 35.1562H14.8438V36.7188H13.2812V35.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 32.0312H8.59375V33.5938H7.03125V32.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 35.1562H8.59375V36.7188H7.03125V35.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 13.2812H19.5312V17.9688H33.5938V13.2812ZM32.0312 16.4062H21.0938V14.8438H32.0312V16.4062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 16.4062H42.9688V17.9688H41.4062V16.4062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 16.4062H46.0938V17.9688H44.5312V16.4062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 19.5312H46.0938V21.0938H44.5312V19.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 19.5312H42.9688V21.0938H41.4062V19.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 22.6562H42.9688V24.2188H41.4062V22.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 22.6562H46.0938V24.2188H44.5312V22.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 25.7812H46.0938V27.3438H44.5312V25.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 25.7812H42.9688V27.3438H41.4062V25.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2188 10.1562V7.8125C49.2188 4.79766 46.7648 2.34375 43.75 2.34375C40.7352 2.34375 38.2812 4.79766 38.2812 7.8125V10.1562H39.8438V13.2812H38.2812V29.5016C37.7242 28.3508 37.2078 27.182 36.7188 26.0016V10.1562H35.1562V3.90625H32.8125V0.78125H20.3125V3.90625H17.9688V10.1562H16.4062V25.7812H10.1562V28.9062H3.90625V43.5039C2.06172 44.3844 0.78125 46.2617 0.78125 48.4375V49.2188H49.2188V47.6562H44.5312V42.8883C47.1766 42.3984 49.2188 39.4727 49.2188 35.9375V13.2812H47.6562V10.1562H49.2188ZM39.8438 7.8125C39.8438 5.65859 41.5961 3.90625 43.75 3.90625C45.9039 3.90625 47.6562 5.65859 47.6562 7.8125V8.59375H39.8438V7.8125ZM41.4062 10.1562H42.9688V13.2812H41.4062V10.1562ZM35.1562 35.9375V33.2305L37.1523 31.9L36.2859 30.6L35.1562 31.3531V29.6875H33.5938V33.2703L32.5836 32.2602L31.4789 33.3648L33.5938 35.4797V35.9375H28.7492C30.8664 32.4688 32.6742 28.7938 34.1336 25H34.6172C36.0758 28.7938 37.8844 32.4688 40.0016 35.9375H35.1562ZM21.875 2.34375H31.25V3.90625H21.875V2.34375ZM19.5312 5.46875H33.5938V10.1562H32.0312V7.03125H30.4688V10.1562H28.9062V7.03125H27.3438V10.1562H25.7812V7.03125H24.2188V10.1562H22.6562V7.03125H21.0938V10.1562H19.5312V5.46875ZM17.9688 11.7188H35.1562V23.4375H33.5938V19.5312H19.5312V24.2188H32.7516C31.2305 28.2195 29.3172 32.0875 27.0508 35.7148L25.9344 37.5H33.5938V43.0469C32.55 41.9727 31.0773 41.3242 29.4555 41.4117C28.7758 39.1367 26.6437 37.5 24.2188 37.5V25.7812H17.9688V11.7188ZM32.0312 21.0938V22.6562H21.0938V21.0938H32.0312ZM11.7188 27.3438H22.6562V37.7398C20.8703 38.2703 19.4539 39.6734 18.9508 41.4969C18.2094 41.3594 17.4484 41.3805 16.7219 41.5508C15.8609 39.5922 13.9047 38.2812 11.7188 38.2812V27.3438ZM5.46875 30.4688H10.1562V38.5117C9.59141 38.6805 9.06563 38.9383 8.59375 39.2687V38.2812H7.03125V39.8438H7.90156C7.06094 40.6648 6.48047 41.7508 6.30547 42.9688C6.2875 42.9688 6.26797 42.9688 6.25 42.9688C5.98438 42.9688 5.725 42.9945 5.46875 43.0312V30.4688ZM6.25 44.5312C6.45312 44.5312 6.66719 44.5508 6.90391 44.5906L7.8125 44.6758V43.75C7.8125 41.5961 9.56484 39.8438 11.7188 39.8438C13.475 39.8438 15.0234 41.0297 15.4844 42.7258L15.7141 43.5719L16.5273 43.2469C17.4102 42.8961 18.3766 42.8742 19.2937 43.2039L20.2305 43.5422L20.3352 42.5516C20.5461 40.5625 22.2156 39.0625 24.2188 39.0625C26.1328 39.0625 27.7906 40.4898 28.0758 42.3828L28.1961 43.1805L28.9883 43.0352C29.2352 42.9906 29.4633 42.9688 29.6875 42.9688C31.8414 42.9688 33.5938 44.7211 33.5938 46.875V47.6562H2.42266C2.78516 45.8758 4.36328 44.5312 6.25 44.5312ZM35.1562 47.6562V46.875V37.5H38.418C38.9156 40.3367 40.7383 42.4773 42.9688 42.8898V47.6562H35.1562ZM43.75 41.4062C42.007 41.4062 40.4969 39.7766 40.0102 37.5H42.8148L41.6992 35.7148C41.2188 34.9461 40.7641 34.1609 40.3156 33.3719C40.9969 31.6023 42.3125 30.4688 43.75 30.4688C45.9039 30.4688 47.6562 32.9227 47.6562 35.9375C47.6562 38.9523 45.9039 41.4062 43.75 41.4062ZM43.75 28.9062C42.2422 28.9062 40.8516 29.7039 39.8438 31.0297V14.8438H47.6562V31.0266C46.6625 29.7203 45.2797 28.9062 43.75 28.9062ZM46.0938 13.2812H44.5312V10.1562H46.0938V13.2812Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_1520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTown1);
export default __webpack_public_path__ + "static/media/town1.012cc446d73a05f5cf195d0a8f31c4d3.svg";
export { ForwardRef as ReactComponent };